import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMsal } from '@azure/msal-react'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'

// import { useCustomization } from '../../../data/customization'
import Config from '../../../utils/config'

function AuthenticationPanel(): ReactElement {
  const { t } = useTranslation()
  const { instance } = useMsal()
  // const { data } = useCustomization()

  const handleLogin = (): void => {
    instance.loginRedirect({
      scopes: Config.auth.scopes,
      redirectUri: window.location.href,
    })
  }

  return (
    <>
      <div className="authentication-panel grid p-0 m-0">
        {/* image */}
        <div
          className="hero hidden md:block md:col-6"
          style={{ backgroundImage: 'url(/customization/default/background.jpg)' }}
        ></div>

        {/* login */}
        <div className="login col-12 md:col-6 flex flex-column justify-content-end">
          <div className="loginWrapper flex flex-column justify-content-center">
            <div className="loginText">
              {/* logo */}
              <img
                src="/customization/default/logo.svg"
                alt={t('login.img.alt')}
                className="companyLogo"
              />

              {/* title */}
              <h1>
                <span className="title">{t('login.title')}</span>
                <span className="subtitle">{t('login.subtitle')}</span>
              </h1>

              {/* text */}
              <p className="intro">{t('login.body')}</p>

              {/* button */}
              <Button
                label={t('login.labels.buttonSignIn')}
                className="button p-button"
                onClick={() => handleLogin()}
              />
            </div>
          </div>

          {/* footer */}
          {
            //   <footer>
            //   <small className="footerLinks">
            //     <ul>
            //       <li>
            //         <a href="https://nttdata-solutions.com/de/contact/">{t('login.footer.help')}</a>
            //       </li>
            //       <li>
            //         <a href="https://nttdata-solutions.com/de/contact/">
            //           {t('login.footer.privacyPolice')}
            //         </a>
            //       </li>
            //       <li>
            //         <a href="https://nttdata-solutions.com/de/contact/">
            //           {t('login.footer.termsOfUse')}
            //         </a>
            //       </li>
            //       <li>
            //         <a href="https://nttdata-solutions.com/de/contact/">
            //           {t('login.footer.imprint')}
            //         </a>
            //       </li>
            //     </ul>
            //   </small>
            //   <Divider className="divider" />
            //   <small className="footerCopyright">
            //     © {new Date().getFullYear()} {t('login.footer.company')}
            //   </small>
            // </footer>
          }
        </div>
      </div>
    </>
  )
}

export default AuthenticationPanel
